module.exports = __webpack_public_path__ + "resources/bootstrap/fonts/glyphicons-halflings-regular.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/bootstrap/fonts/glyphicons-halflings-regular.svg
// module id = 337
// module chunks = 0